interface TooltipRow {
	color: string;
	text: string;
}

interface ChartTooltipProps {
	title?: string;
	rows: TooltipRow[];
	/** Muted lines under the rows, e.g. the master tenant's share. */
	details?: string[];
}

/** The tooltip box every dashboard chart renders as its Recharts `content`. */
function ChartTooltip({ title, rows, details = [] }: ChartTooltipProps) {
	return (
		<div className="dashboard-tooltip">
			{title && <div className="dashboard-tooltip__title">{title}</div>}
			{rows.map((row) => (
				<div key={row.text} className="dashboard-tooltip__row">
					<span
						className="dashboard-tooltip__swatch"
						style={{ background: row.color }}
					/>
					{row.text}
				</div>
			))}
			{details.map((detail) => (
				<div key={detail} className="dashboard-tooltip__detail">
					{detail}
				</div>
			))}
		</div>
	);
}

export default ChartTooltip;
